import { string, shape, number } from 'prop-types'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { styles } from './styles'
import Product from './Product'

const ProductItem = ({ product }) => {
  const { name, image, sku, stock, currency, price, orderId } = product
  return (
    <>
      <Product image={image} name={name} css={styles.product}>
        {sku}
      </Product>
      <span css={[styles.stock, orderId && text.styles.italic]}>
        {orderId ? 'Item already added' : `${stock} in stock`}
      </span>
      <span>{`${currency}${price}`}</span>
    </>
  )
}

ProductItem.propTypes = {
  product: shape({
    image: string,
    name: string,
    sku: string,
    stock: number,
  }).isRequired,
}

ProductItem.defaultProps = {}

export default ProductItem
